module.exports = __webpack_public_path__ + "static/banner-img-appdev-1ade012aabc2aac12b2601b51012cccd.png";